import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppStore } from "@/store";
import { usePermit } from "@/hooks/use-permits";
import { ParametersEditor } from "@/components/parameters/parameters-editor";
import { PageHeader, Breadcrumbs, PageSkeleton, Button } from "@/components/ui";

export const Route = createFileRoute("/_authenticated/permits/$permitId/parameters")({
  component: PermitParametersPage,
});

function PermitParametersPage() {
  const { t } = useTranslation("permits");
  const { permitId } = Route.useParams();

  const orgId = useAppStore((s) => s.activeOrgId);
  const { data: permit, isLoading } = usePermit(orgId, permitId);

  if (isLoading) {
    return (
      <div className="p-8">
        <PageSkeleton />
      </div>
    );
  }

  return (
    <div className="p-8">
      <Breadcrumbs
        items={[
          { label: t("title"), to: "/permits" },
          {
            label: permit?.permit_number ?? permitId,
            to: `/permits/${permitId}`,
          },
          { label: t("bulkEditor.title") },
        ]}
      />
      <PageHeader
        title={t("bulkEditor.title")}
        actions={
          <Link to="/permits/$permitId" params={{ permitId }}>
            <Button variant="secondary">{t("parameters.backToPermit")}</Button>
          </Link>
        }
      />

      <div className="mt-6">
        <ParametersEditor
          ctx={{
            mode: "permit",
            orgId: orgId ?? "",
            facilityId: permit?.facility_id ?? "",
            permitId,
          }}
        />
      </div>
    </div>
  );
}
